// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__u1kfs","ranges":"BmiRanges_ranges__v10AA"};